export default __webpack_public_path__ + "static/media/addApplication.134e7424.svg";